export const data = [
  {
    date: "Mar 22",
    Sales: 2890,
    SignUp: 2338,
    Reward: 2452,
  },
  {
    date: "Mar 23",
    Sales: 2756,
    SignUp: 2103,
    Reward: 2402,
  },
  {
    date: "Mar 24",
    Sales: 3322,
    SignUp: 986,
    Reward: 1821,
  },
  {
    date: "Mar 25",
    Sales: 3470,
    SignUp: 2108,
    Reward: 2809,
  },
  {
    date: "Mar 26",
    Sales: 3129,
    SignUp: 1726,
    Reward: 2290,
  },
];
